import './index.scss'
$("header .nav li").eq(5).addClass("active");
$(".select").click(function () {
    $(this).parent().addClass("active").siblings().removeClass("active");
    $(".table-xl").slideUp(0);
    $(this).parent().next().slideDown();
    
})